// meetingIcons.js
// Shared status icons (calendar + coloured badge) used across the module.
// Your bundler turns these imports into URLs.

import scheduled from "./icons/meeting-scheduled.png"; // blue check
import rescheduled from "./icons/meeting-rescheduled.png"; // amber clock
import cancelled from "./icons/meeting-cancelled.png"; // red x

// Map a meeting status to its icon. "completed" reuses the blue-check calendar.
export const MEETING_ICON = {
  scheduled,
  completed: scheduled,
  rescheduled,
  cancelled,
};

// Icon for a "scheduled" meeting note (Upcoming card, Reschedule, Cancel).
export const meetingNoteIcon = scheduled;